import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import type { Auth0Config } from '@/services/interfaces/Auth';
import { validateAuth0Config } from '@/lib/auth/authConfig';
import { getAppAuth0Config } from '@/lib/auth/appConfig';

interface Auth0ProviderWrapperProps {
  children: React.ReactNode;
  config?: Auth0Config;
  onRedirectCallback?: (appState?: any) => void;
}

export const Auth0ProviderWrapper: React.FC<Auth0ProviderWrapperProps> = ({
  children,
  config,
  onRedirectCallback,
}) => {
  const auth0Config = config || getAppAuth0Config();
  
  // 验证配置
  if (!validateAuth0Config(auth0Config)) {
    console.error('Invalid Auth0 configuration:', auth0Config);
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-red-600 mb-2">
            Auth0 Configuration Error
          </h2>
          <p className="text-gray-600">
            Please check your Auth0 environment variables.
          </p>
        </div>
      </div>
    );
  }

  const handleRedirectCallback = (appState?: any) => {
    if (onRedirectCallback) {
      onRedirectCallback(appState);
    } else {
      // 🔑 Auth0回调处理完成后，保持在当前回调页面
      // 让AuthCallbackPage组件处理后续的页面跳转
      console.log('Auth0 redirect callback processed');
    }
  };

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: auth0Config.redirectUri,
        audience: auth0Config.audience,
        scope: auth0Config.scope,
      }}
      onRedirectCallback={handleRedirectCallback}
      // useRefreshTokens={true}
      // cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};
